import React, { lazy, Suspense, useMemo } from 'react';

import { useSelector } from 'react-redux';
import { envIsCanada, envIsMexico, envIsNormal } from '@/constants/constants';
import { selectLocale } from '@/store/selectors/commonSelectors';
import GamesLobbyWrapper from '@/pages/games/lobby/lobby-sections-streamlines/GamesLobbyWrapper';

const GamesLobbyMexico = lazy(() => import('./GamesLobbyMexico'));
const GamesLobbyNormal = lazy(() => import('./GamesLobbyNormal'));
const GamesLobbyThailand = lazy(() => import('./GamesLobbyThailand'));
const GamesLobbyCanada = lazy(() => import('./GamesLobbyCanada'));

function GamesLobby(): JSX.Element {
  const locale = useSelector(selectLocale);

  const LobbyComponent = useMemo(() => {
    if (envIsMexico()) {
      return <GamesLobbyMexico />;
    }
    if (envIsCanada()) {
      return <GamesLobbyCanada />;
    }

    if (envIsNormal() && locale === 'th') {
      return <GamesLobbyThailand />;
    }

    return <GamesLobbyNormal />;
  }, [locale]);

  return (
    <Suspense fallback={<div className="w-full min-h-[100vh]" />}>
      <GamesLobbyWrapper>{LobbyComponent}</GamesLobbyWrapper>
    </Suspense>
  );
}

export default GamesLobby;
